import PageStyle from "@/styles/pages/errors/_index.module.scss";
import Image from 'next/image';
import Error from '/public/images/errors/404.png';
import {REDIRECT, useRouter, getSession, useEffect, useState, useTranslation } from '@/imports-files/common/common';



export default function Error404(props){
  const { t } = useTranslation();
  const [session, setSession] = useState();
  const [butonText, setButtonText] = useState('login');
  const [isLoading, setLoading]  =    useState(true);
  const client_login_url    =   REDIRECT.client.login;
  const admin_login_url     =   REDIRECT.admins.login;
  const agency_login_url    =   REDIRECT.agency.login;
  const router = useRouter();
  
  useEffect(async() => {
    await setSession(await getSession())
    if(router.pathname.includes('view-job') || router.pathname.includes('offer-detail')){
      await setButtonText('login')
    }
    else if(session){
      await setButtonText('go to dashboard')
    }
    setLoading(false);
  }, [isLoading])

  function errorAction(session){
    if (typeof document != "undefined"){
      if(document.querySelector('.MainSidebar')) document.querySelector('.MainSidebar').style.display =''
      if(document.querySelector('.TopRightCurve')) document.querySelector('.TopRightCurve').style.display =''
      if(document.querySelector('.BottomRightCurve')) document.querySelector('.BottomRightCurve').style.display =''
      if(document.querySelector('.SubSidebar')) document.querySelector('.SubSidebar').style.display =''
      if(router.pathname.includes('view-job') || router.pathname.includes('offer-detail'))
      {
        router.push(process.env.NEXT_PUBLIC_BASE_URL + client_login_url)
      }
      else if(session?.type == "Admin")
      {
        router.push(REDIRECT.admins.dashboard.activities);
      }

      else if (session?.type == "ClientUser")
      {
        router.push(REDIRECT.client.activities);
      }

      else if (session?.type == "AgencyUser")
      {
        router.push(REDIRECT.agency.dashboard.activities);
      }

      else {
        if (router.pathname.includes('/admins/dashboard/'))
        {  router.push(process.env.NEXT_PUBLIC_BASE_URL + admin_login_url) }
        else if(router.pathname.includes('/agency/dashboard/'))
        {
          router.push(process.env.NEXT_PUBLIC_BASE_URL + agency_login_url)
        }
        else
        {
          router.push(process.env.NEXT_PUBLIC_BASE_URL + client_login_url)
        }
      }
    }
  }
  if (typeof document != "undefined"){
    if(document.querySelector('.MainSidebar')) document.querySelector('.MainSidebar').style.display ='none'
    if(document.querySelector('.TopRightCurve')) document.querySelector('.TopRightCurve').style.display ='none'
    if(document.querySelector('.BottomRightCurve')) document.querySelector('.BottomRightCurve').style.display ='none'
    if(document.querySelector('.SubSidebar')) document.querySelector('.SubSidebar').style.display ='none'
  }
    if(isLoading){
      return null
    }
    return (
    
    <div className={`${PageStyle.NewJob}`}>
    <div className={PageStyle.NewJob__Container}>
      <div className={PageStyle.Error}>
          <Image src='/images/errors/404.png' height={210} width={305} alt=''></Image>

          <h1>404</h1>

          <h3>{t('errors:not_found')}</h3>

           <p>{t('errors:wrong_location')} </p>

          <span onClick = {() => errorAction(session)}>
            <span className={PageStyle.primarybtn}>{butonText}</span>
          </span>
     </div>
      </div></div>
    )
}